module.exports = __webpack_public_path__ + "images/home/orientation/new-user.c95fada45e5b8a72f20d.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/home/orientation/new-user.svg
// module id = TL9t
// module chunks = 24